/**
 * DijitalMask (dijital-mask)
 * Türkiye Kurumsal Standartlarına Özel Bağımsız Girdi Maskeleme ve Doğrulama Kütüphanesi
 * 
 * Sıfır dış bağımlılık. Vanilla ES6+.
 * TCKN, VKN, IBAN (Banka Tespiti), Para/Döviz, Telefon, Plaka, Kredi Kartı.
 * 
 * @author DijitalUI Team
 * @license MIT
 */

// ============================================================================
// 1. TÜRKİYE BANKA VE FİNANS KURULUŞLARI LİSTESİ
// ============================================================================
export const TURKISH_BANKS = {
  // Kamu Mevduat Bankaları
  '00010': { 
    code: '00010', 
    name: 'T.C. Ziraat Bankası A.Ş.', 
    shortName: 'Ziraat', 
    icon: `<svg width="18" height="18" viewBox="116 64 38 65"><path fill="#A8353D" d="M 131.44 101.97 C 132.24 101.27 131.8 100.35 131.32 99.72 L 118.5 87.72 C 117.84 87.1 117.27 87.53 116.74 88.08 C 116.27 88.58 116.07 89.28 116.32 89.96 C 116.59 90.7 117.22 91.13 117.84 91.68 L 128.53 102.32 C 129.58 103.26 130.43 102.83 131.44 101.97 Z"/><path fill="#E12627" d="M 131.12 116.91 C 131.21 117 131.32 117.07 131.44 117.12 C 132.24 117.82 131.8 118.74 131.32 119.37 L 118.5 131.37 C 117.84 131.99 117.27 131.56 116.74 131.01 C 116.27 130.51 116.07 129.81 116.32 129.13 C 116.59 128.39 117.22 127.96 117.84 127.41 L 128.53 116.77 C 129.5 115.9 130.34 116.18 131.12 116.91 Z"/><path fill="#A8353D" d="M 120.27 107.8 L 117.44 110.17 C 117.15 110.44 117.01 110.72 117.06 111.08 C 117.1 111.44 117.34 111.66 117.65 111.75 C 118.06 111.85 118.52 111.69 118.84 111.41 L 121.71 108.97 C 122.25 108.52 122.23 107.97 121.84 107.56 C 121.46 107.15 120.81 107.35 120.27 107.8 Z"/><path fill="#E12627" d="M 132.5 125.64 C 132.28 125.16 131.99 124.72 131.62 124.35 L 118.17 111.77 C 117.6 111.23 116.73 111.48 116.27 112.06 C 115.82 112.63 115.98 113.51 116.49 114.07 L 129.6 126.85 C 130.45 127.68 131.39 127.94 132.32 127.31 C 132.58 126.82 132.65 126.24 132.5 125.64 Z"/><path fill="#E12627" d="M 132.49 87.08 C 132.28 86.6 131.99 86.16 131.62 85.8 L 117.8 72.82 C 117.23 72.28 116.36 72.53 115.9 73.11 C 115.45 73.68 115.61 74.56 116.12 75.12 L 129.6 88.08 C 130.45 88.91 131.39 89.17 132.32 88.54 C 132.57 88.05 132.64 87.47 132.49 87.08 Z"/><path fill="#A8353D" d="M 137.03 117.07 L 137.03 124.12 L 139.74 121.85 L 139.74 114.83 Z"/><path fill="#A8353D" d="M 139.75 97.32 L 139.6 97.43 L 137.27 99.39 C 137.21 99.45 137.09 99.48 137.03 99.44 L 137.03 92.42 L 139.74 94.7 C 139.75 95.57 139.75 96.45 139.75 97.32 Z"/><path fill="#E12627" d="M 151.78 99.82 C 152.11 99.38 152.33 98.85 152.33 98.13 L 152.33 73.15 C 152.33 72.48 151.64 71.9 150.98 72.16 C 150.41 72.39 150.04 72.93 149.97 73.54 L 137.03 84.45 L 137.03 91.51 L 149.62 80.9 C 149.64 83.21 149.64 100.91 149.64 103.22 L 137.03 113.84 L 137.03 120.9 L 149.97 110.02 C 150.31 109.73 150.81 109.83 151.05 110.21 C 151.48 110.89 151.42 111.78 150.89 112.39 L 138.83 126.17 C 138.38 126.69 138.48 127.49 139.02 127.9 C 139.53 128.28 140.23 128.16 140.63 127.64 L 152.33 113.88 L 152.33 103.5 C 152.33 102.13 151.27 100.5 151.78 99.82 Z"/><path fill="#E12627" d="M 132.76 69.13 L 118.94 82.21 C 118.42 82.71 118.47 83.56 119.04 83.99 C 119.56 84.38 120.3 84.29 120.73 83.78 L 133.72 70.83 C 134.19 70.36 134.2 69.58 133.74 69.1 C 133.48 68.83 133.08 68.83 132.76 69.13 Z"/><path fill="#E12627" d="M 142.79 68.4 C 142.91 68.24 142.92 68.04 142.82 67.89 L 136.75 58.79 C 136.37 58.23 135.58 58.12 135.04 58.55 C 134.52 58.97 134.46 59.73 134.89 60.23 L 140.66 69.49 C 141.05 70.07 141.83 70.25 142.42 69.89 C 142.61 69.77 142.77 69.41 142.79 68.4 Z"/></svg>`, 
    color: '#be1622', 
    bg: 'rgba(190, 22, 34, 0.12)' 
  },
  '00012': { 
    code: '00012', 
    name: 'Türkiye Halk Bankası A.Ş.', 
    shortName: 'Halkbank', 
    icon: `<svg width="18" height="18" viewBox="0 0 100 100"><path fill="#00559f" d="M50 0L93.3 25v50L50 100 6.7 75V25L50 0zm-20 28v44h12v-16h16v16h12V28H58v16H42V28H30z"/></svg>`, 
    color: '#00559f', 
    bg: 'rgba(0, 85, 159, 0.12)' 
  },
  '00015': { 
    code: '00015', 
    name: 'Türkiye Vakıflar Bankası T.A.O.', 
    shortName: 'VakıfBank', 
    icon: `<svg width="18" height="14" viewBox="4 4 22 16"><path fill="#fbc34e" d="M 24.687,8.707 C 24.939,7.271 23.617,5.27 20.018,5.27 H 11.075 C 8.624,5.27 7.087,6.953 6.814,8.648 L 5,18.184 c 1.593,-0.004 12.089,0 12.067,0 h 0.682 c 3.759,-0.021 5.923,-0.865 6.318,-3.593 0.262,-1.836 -1.35,-3.021 -2.667,-3.273 1.332,-0.243 2.951,-0.696 3.287,-2.611 z"/><path fill="#ffffff" d="m 16.289,9.266 c -0.912,1.155 -4.227,5.164 -4.897,5.925 -1.497,1.703 -4.584,1.449 -4.605,1.406 0,-0.002 1.113,-5.265 1.474,-6.749 0.989,-4.035 4.401,-3.08 4.401,-3.08 0,0 -0.909,0.131 -1.551,0.95 -0.651,0.83 -1.389,4.874 -1.806,6.764 1.955,-2.285 4.635,-5.233 5.092,-5.785 1.948,-2.358 4.999,-2.033 4.999,-2.033 0,0 -1.188,0.166 -3.107,2.602 z"/></svg>`, 
    color: '#b58500', 
    bg: 'rgba(234, 170, 0, 0.15)' 
  },
  
  // Özel Mevduat Bankaları
  '00046': { 
    code: '00046', 
    name: 'Akbank T.A.Ş.', 
    shortName: 'Akbank', 
    icon: `<svg width="18" height="15" viewBox="0 0 28 24"><rect width="28" height="24" rx="3" fill="#DC0005"/><path d="M5.5 4l-4.5 16h2.8l.6-2.3h5.3l.6 2.3h2.8L8.6 4H5.5zm1.1 9.5l1.6-6 1.6 6H6.6zm13.8-9.5l-4.5 16h2.8l.6-2.3h5.3l.6 2.3h2.8L23.4 4h-3.1zm1.1 9.5l1.6-6 1.6 6h-3.2z" fill="#ffffff"/></svg>`, 
    color: '#ed1c24', 
    bg: 'rgba(237, 28, 36, 0.12)' 
  },
  '00062': { 
    code: '00062', 
    name: 'Garanti BBVA A.Ş.', 
    shortName: 'Garanti BBVA', 
    icon: `<svg width="18" height="18" viewBox="0 0 46 68"><path fill="#009a44" d="M33.59,31.49c0,0,7.97-6.07,11.33-17.57c0,0,3.77,2.91,1.01,9.11C45.93,23.03,40.97,33.22,33.59,31.49L33.59,31.49z M39.22,22.01c-2.93,4.7-6.9,8.05-6.9,8.05s-0.99-14.58,2.89-21.27c0,0,2.85-4.65,6.05-1.81c0,0,1.85,1.35,2.21,5.19c0,0,0.05,0.28-0.21,1.05C42.64,15.11,41.1,19,39.22,22.01L39.22,22.01z M14.54,67.85c0,0-2.53-1.99-3.48-5.73c0,0,10.41-6.44,18-23.97c0,0,2.74,10.5-3.59,24.06C25.48,62.21,21,72.05,14.54,67.85L14.54,67.85z M10.65,6.16c0,0,1.77-6.67,6.23-6.13c0,0,6.59-0.04,9.89,9.71c0,0,3.43,9.12,1.99,18.15C28.76,27.89,24.42,15.01,10.65,6.16L10.65,6.16z M27.39,30.25c0,0-8.12,4.27-19.25-2.66c0,0-10.08-6.51-5.04-15.19c0,0,2.45-3.29,5.6-4.06C8.7,8.35,20.95,14.3,27.39,30.25L27.39,30.25z M11.79,39.04c0,0,2.21-1.25,4.9-2.27c1.47-0.55,2.94-0.91,4.58-1.24c2.95-0.6,6.45,0.26,6.45,0.26s-6.1,15.67-18.73,23.97c-4.88-2.08-6.45-6.73-6.45-6.73C-0.22,45.23,11.79,39.04,11.79,39.04L11.79,39.04z M38.31,42.87c1.25,2.31,2.34,4.77,3.17,7.04c0.92,2.5,1.54,4.71,1.54,4.71s-0.41,3.93-3.25,4.38c0,0-4.61,1.67-6.32-6.73c0,0-1.54-9.48-0.5-16.21C32.96,36.06,35.92,38.46,38.31,42.87L38.31,42.87z M37.66,38.24c-1.68-2.17-3.12-3.4-3.12-3.4s6.05-0.09,10.79,6.28c0,0,4.16,5.15-0.72,11.7c0,0-1.11-4.9-3.47-9.12C40.06,41.77,38.82,39.73,37.66,38.24L37.66,38.24z"/></svg>`, 
    color: '#009a44', 
    bg: 'rgba(0, 154, 68, 0.12)' 
  },
  '00064': { 
    code: '00064', 
    name: 'Türkiye İş Bankası A.Ş.', 
    shortName: 'İş Bankası', 
    icon: `<svg width="18" height="18" viewBox="78 84 32 37"><path fill="#004990" d="M89.2 86.9c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7 0-1.5-1.2-2.7-2.7-2.7-1.5 0-2.7 1.2-2.7 2.7zm17.3 18.2c-.3 1-.7 1.8-1 2.2-.6.9-1.1 1.4-1.1 1.4h-.7c0 0 .3-1.2.2-1.5-.1-.3-.2-.5-.5-.7-1-.3-1.7-1.2-1.7-2.3 0-1 .6-1.9 1.5-2.4-1-.2-1.9-.5-3-.9l-1.8-.6c-1.3-.3-2.6 0-3.3.7-.4.4-.7 1-.7 1.7 0 1.3.8 2.3 1.9 2.8 1.3.6 3.4 1.8 3.4 1.8l1.6 1.1c1.8 1.6 3.2 4 3.2 6.6 0 .8-.1 1.6-.3 2.3 0 0-1.1 4.3-6 5.9 0 0-1.4.6-2.9.7 0 0-.1 0-.2 0 .7.5 1.2 1.3 1.2 2.2 0 .7-.3 1.1-.6 1.6-.2.3-.7 1.1-.9 1.5-.6.9-1.1 1.4-1.1 1.4h-.7c0 0 .3-1.2.2-1.5-.1-.3-.2-.5-.5-.7-1-.3-1.7-1.2-1.7-2.3 0-1 .6-1.9 1.5-2.4-1-.2-1.9-.5-3-.9l-1.8-.6v5.8c0 .4.2 1.5 1.2 1.9l.6.2v.7h-8.3v-.7l.7-.2c1.3-.3 1.1-1.5 1.1-1.9v-8.4l-.8-.4c-1.4-.8-2.2-1.1-3.4-2-2.2-1.7-3.6-3.5-3.6-6.5 0-4 3-7.3 7.2-7.9.2 0 .4-.1.6-.1v-.9c0-.3.2-1.5-1.2-1.9l-.6-.2v-.7h8.3v.7l-.7.2c-1.3.3-1.1 1.5-1.1 1.9v8.4l4.6 2.6v-8.6c-.2 0-.4 0-.4 0-2.4.4-4.4 2-4.4 4.2 0 1.5.6 2.6 1.6 3.4 0 0 .6.6 1.9 1.4 1.3.8 6.4 3.6 6.4 3.6s3 1.6 4 2.4c.5.3 1 .9 1 1.9 0 .8-.4 1.5-.9 1.9z"/></svg>`, 
    color: '#004990', 
    bg: 'rgba(0, 73, 144, 0.12)' 
  },
  '00067': { 
    code: '00067', 
    name: 'Yapı ve Kredi Bankası A.Ş.', 
    shortName: 'Yapı Kredi', 
    icon: `<svg width="22" height="13" viewBox="0 0 66 34"><path fill="#004587" d="M65.46 10.928C61.861.6 51.571.029 50.515 0a18.918 18.918 0 0 0-13.557 5.295 24.157 24.157 0 0 0-3.843 4.773 24.089 24.089 0 0 0-3.834-4.773A18.936 18.936 0 0 0 15.715 0C14.662.029 4.371.6.782 10.928a15.679 15.679 0 0 0 .919 12c1.9 4.059 6.426 7.369 11.2 7.034a9.8 9.8 0 0 0 8.657-5.838 8.442 8.442 0 0 0-1.9-9.3 3.388 3.388 0 0 1-.587 2.545 3.763 3.763 0 0 1-4.6 1.24 3.057 3.057 0 0 1-2-3.356 3.574 3.574 0 0 1 2.21-2.748c2.093-.906 4.02-.446 5.908 1.351 3.08 3.448 3.442 8.673 4.909 12.639 1.038 3.264 2.682 6.1 6.279 6.915a5.88 5.88 0 0 0 1.341.145 5.785 5.785 0 0 0 1.339-.145c3.6-.812 5.243-3.651 6.281-6.915 1.466-3.966 1.828-9.191 4.919-12.639 1.878-1.8 3.805-2.257 5.9-1.351a3.571 3.571 0 0 1 2.21 2.748 3.045 3.045 0 0 1-2.006 3.356 3.768 3.768 0 0 1-4.6-1.24 3.382 3.382 0 0 1-.587-2.545 8.476 8.476 0 0 0-1.9 9.3 9.8 9.8 0 0 0 8.656 5.838c4.774.335 9.3-2.975 11.2-7.034a15.685 15.685 0 0 0 .931-12m-7.268 12.321a7.027 7.027 0 0 1-7.453 1.419 5.064 5.064 0 0 1-2.769-3.2c1.986 1.974 5.565 2.982 8.853-.479 0 0 3.072-2.848 1.33-8.214-.87-2.655-4.118-4.863-6.828-5.137a10.327 10.327 0 0 0-10.474 4.416c-3.11 4.8-3.5 10.14-5.752 15.478a2.222 2.222 0 0 1-3.969 0c-2.249-5.338-2.641-10.681-5.75-15.478A10.322 10.322 0 0 0 14.9 7.637c-2.7.274-5.955 2.482-6.828 5.137-1.74 5.366 1.331 8.214 1.331 8.214 3.287 3.462 6.866 2.453 8.862.479a5.1 5.1 0 0 1-2.779 3.2 7.026 7.026 0 0 1-7.452-1.419A10.342 10.342 0 0 1 5.6 12.165c1.55-4.591 6.194-6.895 9.891-7.185 4.372-.385 10.407 2.3 12.823 6.872.558 1.057 1.741 3.785 1.741 3.785h6.132s1.174-2.728 1.74-3.785C40.332 7.278 46.367 4.6 50.74 4.98c3.7.29 8.342 2.594 9.885 7.185a10.322 10.322 0 0 1-2.433 11.084"/></svg>`, 
    color: '#163172', 
    bg: 'rgba(22, 49, 114, 0.12)' 
  },
  '00111': { code: '00111', name: 'QNB Finansbank A.Ş.', shortName: 'QNB', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#5b0b4b"/><rect x="8" y="8" width="8" height="8" rx="2" fill="#ffffff"/></svg>`, color: '#5b0b4b', bg: 'rgba(91, 11, 75, 0.12)' },
  '00032': { code: '00032', name: 'Türk Ekonomi Bankası A.Ş.', shortName: 'TEB', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><rect width="24" height="24" rx="4" fill="#00965e"/><rect x="5" y="5" width="6" height="6" fill="#ffffff"/><rect x="13" y="13" width="6" height="6" fill="#ffffff"/></svg>`, color: '#00965e', bg: 'rgba(0, 150, 94, 0.12)' },
  '00134': { code: '00134', name: 'DenizBank A.Ş.', shortName: 'DenizBank', icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="#002f6c"><path d="M12 2a3 3 0 0 0-3 3c0 1.3.8 2.4 2 2.8V10H8v2h3v7.9A8 8 0 0 1 4 12H2a10 10 0 0 0 9 9.9V12h2v7.9A10 10 0 0 0 22 12h-2a8 8 0 0 1-7 7.9V12h3v-2h-3V7.8c1.2-.4 2-1.5 2-2.8a3 3 0 0 0-3-3z"/></svg>`, color: '#002f6c', bg: 'rgba(0, 47, 108, 0.12)' },
  '00059': { code: '00059', name: 'Şekerbank T.A.Ş.', shortName: 'Şekerbank', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#138942"/><circle cx="12" cy="12" r="4" fill="#ffffff"/></svg>`, color: '#138942', bg: 'rgba(19, 137, 66, 0.12)' },
  '00103': { code: '00103', name: 'Fibabanka A.Ş.', shortName: 'Fibabanka', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><rect width="24" height="24" rx="4" fill="#004f9e"/><polygon points="7,7 17,12 7,17" fill="#ffffff"/></svg>`, color: '#004f9e', bg: 'rgba(0, 79, 158, 0.12)' },
  '00146': { code: '00146', name: 'Odea Bank A.Ş.', shortName: 'Odeabank', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#882384"/><path d="M8 7h5a5 5 0 0 1 0 10H8V7z" fill="#ffffff"/></svg>`, color: '#882384', bg: 'rgba(136, 35, 132, 0.12)' },
  '00099': { code: '00099', name: 'ING Bank A.Ş.', shortName: 'ING', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><rect width="24" height="24" rx="4" fill="#ff6200"/><circle cx="12" cy="12" r="5" fill="#ffffff"/></svg>`, color: '#ff6200', bg: 'rgba(255, 98, 0, 0.12)' },
  '00122': { code: '00122', name: 'HSBC Bank A.Ş.', shortName: 'HSBC', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><polygon points="3,12 12,3 21,12 12,21" fill="#db0011"/><polygon points="8,12 12,8 16,12 12,16" fill="#ffffff"/></svg>`, color: '#db0011', bg: 'rgba(219, 0, 17, 0.12)' },
  '00123': { code: '00123', name: 'ICBC Turkey Bank A.Ş.', shortName: 'ICBC', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#c8102e"/><rect x="7" y="7" width="10" height="10" rx="1" fill="#ffffff"/></svg>`, color: '#c8102e', bg: 'rgba(200, 16, 46, 0.12)' },
  '00124': { code: '00124', name: 'Alternatifbank A.Ş.', shortName: 'Alternatif Bank', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#1e398f"/><polygon points="7,17 12,7 17,17" fill="#ffffff"/></svg>`, color: '#1e398f', bg: 'rgba(30, 57, 143, 0.12)' },
  '00125': { code: '00125', name: 'Burgan Bank A.Ş.', shortName: 'Burgan Bank', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#005b94"/><rect x="8" y="8" width="8" height="8" fill="#ffffff"/></svg>`, color: '#005b94', bg: 'rgba(0, 91, 148, 0.12)' },
  '00135': { code: '00135', name: 'Anadolubank A.Ş.', shortName: 'Anadolubank', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#002d62"/><polygon points="12,6 18,17 6,17" fill="#ffffff"/></svg>`, color: '#002d62', bg: 'rgba(0, 45, 98, 0.12)' },
  '00143': { code: '00143', name: 'Aktif Yatırım Bankası A.Ş.', shortName: 'Aktif Bank', icon: `<svg width="18" height="18" viewBox="0 0 24 24" fill="#ec6608"><polygon points="13,2 4,14 12,14 11,22 20,10 12,10"/></svg>`, color: '#ec6608', bg: 'rgba(236, 102, 8, 0.12)' },

  // Katılım Bankaları
  '00205': { 
    code: '00205', 
    name: 'Kuveyt Türk Katılım Bankası', 
    shortName: 'Kuveyt Türk', 
    icon: `<svg width="18" height="18" viewBox="0 0 41 41"><path fill="#00833e" d="M19.1903 37.2776L17.2657 38.4771L15.9946 35.3946L19.1903 37.2762V37.2776ZM16.1193 28.8199L19.2075 30.733L17.3804 31.9697L16.1193 28.8199ZM16.0219 22.1777L19.2605 24.131L17.3618 25.5052L16.0219 22.1777ZM21.1579 27.5201L24.3234 25.5525L23.0953 28.7783L21.1579 27.5201ZM16.072 32.113L22.0077 35.7099L20.2106 36.8764L17.1325 35.1438L16.072 32.113ZM18.3935 32.3208L24.2633 28.7711L23.3175 31.6243L20.2622 33.6907L18.3935 32.3208ZM16.0749 25.6256L22.0564 29.0592L20.0845 30.4062L17.0981 28.5992L16.0749 25.6256ZM18.309 25.8334L24.2661 22.2465L23.1899 25.3147L20.288 27.0673L18.3076 25.8334H18.309ZM18.1241 22.3999H22.1037L20.2121 23.8931L18.1256 22.3999H18.1241ZM21.1579 33.9172L24.3234 31.9539L23.0953 35.1797L21.1579 33.9186V33.9172ZM20.106 20.1457C20.106 20.1457 16.9046 10.9026 16.2956 9.05257C16.0434 8.29592 15.9431 7.65106 16.4203 7.02052L20.1046 2.19263L23.7818 7.02052C24.2647 7.65106 24.1601 8.29592 23.9107 9.05257C23.3017 10.904 20.106 20.1457 20.106 20.1457ZM38.221 21.2033L21.231 21.2061L28.9722 17.2237C33.2871 15.0011 34.7158 16.8583 36.295 18.8158L38.221 21.2018V21.2033ZM20.8555 20.3506L26.195 10.7808C26.8871 9.54267 28.6584 8.92359 30.2075 9.85363L36.2076 13.4577L33.1954 13.4677C31.8755 13.4677 30.8223 13.9722 29.865 14.5855L20.8555 20.3506ZM1.98242 21.2033L3.91272 18.8173C5.48906 16.8597 6.91636 15.0025 11.2341 17.2252L18.9739 21.2076L1.98385 21.2047L1.98242 21.2033ZM19.3465 20.3506L10.3385 14.5855C9.38262 13.9722 8.32934 13.4677 7.00235 13.4677L3.99584 13.4577L9.99452 9.85363C11.5465 8.92359 13.3192 9.54267 14.0085 10.7808L19.3465 20.3506ZM18.0468 39.1234L24.2633 35.4476L23.0753 39.0202C22.1223 39.1592 21.1507 39.2352 20.1562 39.2352C19.444 39.2352 18.7418 39.1979 18.0453 39.122L18.0468 39.1234Z"/><path fill="#00833e" d="M20.0983 0C8.99946 0 0 8.99803 0 20.0983C0 31.1986 8.99946 40.1966 20.0983 40.1966C31.1972 40.1966 40.1981 31.1986 40.1981 20.0983C40.1981 8.99803 31.2029 0 20.0983 0ZM20.0983 39.2379C9.53112 39.2379 0.961567 30.667 0.961567 20.0983C0.961567 9.52969 9.53112 0.954402 20.0983 0.954402C30.6655 0.954402 39.2451 9.52969 39.2451 20.0983C39.2451 30.667 30.6727 39.2379 20.0983 39.2379Z"/></svg>`, 
    color: '#00833e', 
    bg: 'rgba(0, 131, 62, 0.12)' 
  },
  '00206': { code: '00206', name: 'Türkiye Finans Katılım Bankası', shortName: 'Türkiye Finans', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><rect width="24" height="24" rx="4" fill="#004c97"/><polygon points="7,12 12,7 17,12 12,17" fill="#ffffff"/></svg>`, color: '#004c97', bg: 'rgba(0, 76, 151, 0.12)' },
  '00203': { code: '00203', name: 'Albaraka Türk Katılım Bankası', shortName: 'Albaraka', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#8b1d41"/><path d="M12 7l4 10H8z" fill="#ffffff"/></svg>`, color: '#8b1d41', bg: 'rgba(139, 29, 65, 0.12)' },
  '00209': { code: '00209', name: 'Ziraat Katılım Bankası A.Ş.', shortName: 'Ziraat Katılım', icon: `<svg width="18" height="18" viewBox="116 64 38 65"><path fill="#b31b1b" d="M 131.44 101.97 C 132.24 101.27 131.8 100.35 131.32 99.72 L 118.5 87.72 C 117.84 87.1 117.27 87.53 116.74 88.08 L 128.53 102.32 Z"/><path fill="#b31b1b" d="M 131.12 116.91 C 132.24 117.82 131.8 118.74 131.32 119.37 L 118.5 131.37 C 117.84 131.99 117.27 131.56 116.74 131.01 L 128.53 116.77 Z"/></svg>`, color: '#b31b1b', bg: 'rgba(179, 27, 27, 0.12)' },
  '00210': { code: '00210', name: 'Vakıf Katılım Bankası A.Ş.', shortName: 'Vakıf Katılım', icon: `<svg width="18" height="14" viewBox="4 4 22 16"><path fill="#b58500" d="M 24.687,8.707 C 24.939,7.271 23.617,5.27 20.018,5.27 H 11.075 L 5,18.184 h 12.749 c 3.759,-0.021 5.923,-0.865 6.318,-3.593 z"/></svg>`, color: '#b58500', bg: 'rgba(194, 155, 56, 0.15)' },
  '00213': { code: '00213', name: 'Türkiye Emlak Katılım Bankası', shortName: 'Emlak Katılım', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><rect width="24" height="24" rx="4" fill="#007078"/><rect x="7" y="7" width="10" height="10" fill="#ffffff"/></svg>`, color: '#007078', bg: 'rgba(0, 112, 120, 0.12)' },

  // Dijital & Yeni Nesil Bankalar
  '00108': { 
    code: '00108', 
    name: 'Enpara.com (QNB)', 
    shortName: 'Enpara', 
    icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#7a2278"/><circle cx="12" cy="12" r="4.5" fill="#ffffff"/></svg>`, 
    color: '#7a2278', 
    bg: 'rgba(122, 34, 120, 0.12)' 
  },
  '00211': { 
    code: '00211', 
    name: 'Hayat Finans Katılım Bankası', 
    shortName: 'Hayat Finans', 
    icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#16a34a"/><polygon points="12,6 15,10 19,11 16,14 17,18 12,16 7,18 8,14 5,11 9,10" fill="#ffffff"/></svg>`, 
    color: '#16a34a', 
    bg: 'rgba(22, 163, 74, 0.12)' 
  },
  '00212': { code: '00212', name: 'T.O.M. Katılım Bankası A.Ş.', shortName: 'TOM Bank', icon: `<svg width="18" height="18" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" fill="#ff6600"/><text x="6" y="16" font-family="sans-serif" font-weight="900" font-size="11" fill="#ffffff">TOM</text></svg>`, color: '#ff6600', bg: 'rgba(255, 102, 0, 0.12)' },
  '00801': { 
    code: '00801', 
    name: 'Papara Elektronik Para A.Ş.', 
    shortName: 'Papara', 
    icon: `<svg width="18" height="18" viewBox="0 0 24 24"><rect width="24" height="24" rx="6" fill="#18181b"/><path d="M7 5h6a4.5 4.5 0 0 1 0 9H9.5v5H7V5zm2.5 2.2v4.6h3.5a2.3 2.3 0 0 0 0-4.6H9.5z" fill="#ffffff"/></svg>`, 
    color: '#18181b', 
    bg: 'rgba(24, 24, 27, 0.10)' 
  }
};

// ============================================================================
// 1.1 ULUSLARARASI TELEFON ALAN KODLARI LİSTESİ
// ============================================================================
export const COUNTRY_DIAL_CODES = [
  { code: 'TR', name: 'Türkiye', dial: '+90', flag: '🇹🇷', mask: '(000) 000 00 00', placeholder: '(5XX) XXX XX XX', digits: 10 },
  { code: 'US', name: 'Amerika Birleşik Devletleri', dial: '+1', flag: '🇺🇸', mask: '(000) 000-0000', placeholder: '(XXX) XXX-XXXX', digits: 10 },
  { code: 'DE', name: 'Almanya', dial: '+49', flag: '🇩🇪', mask: '0000 0000000', placeholder: 'XXXX XXXXXXX', digits: 11 },
  { code: 'GB', name: 'Birleşik Krallık', dial: '+44', flag: '🇬🇧', mask: '0000 000000', placeholder: 'XXXX XXXXXX', digits: 10 },
  { code: 'FR', name: 'Fransa', dial: '+33', flag: '🇫🇷', mask: '0 00 00 00 00', placeholder: 'X XX XX XX XX', digits: 9 },
  { code: 'AZ', name: 'Azerbaycan', dial: '+994', flag: '🇦🇿', mask: '00 000 00 00', placeholder: 'XX XXX XX XX', digits: 9 },
  { code: 'NL', name: 'Hollanda', dial: '+31', flag: '🇳🇱', mask: '0 0000 0000', placeholder: 'X XXXX XXXX', digits: 9 },
  { code: 'IT', name: 'İtalya', dial: '+39', flag: '🇮🇹', mask: '000 000 0000', placeholder: 'XXX XXX XXXX', digits: 10 },
  { code: 'ES', name: 'İspanya', dial: '+34', flag: '🇪🇸', mask: '000 00 00 00', placeholder: 'XXX XX XX XX', digits: 9 },
  { code: 'RU', name: 'Rusya', dial: '+7', flag: '🇷🇺', mask: '(000) 000-00-00', placeholder: '(XXX) XXX-XX-XX', digits: 10 },
  { code: 'UA', name: 'Ukrayna', dial: '+380', flag: '🇺🇦', mask: '00 000 0000', placeholder: 'XX XXX XXXX', digits: 9 },
  { code: 'BE', name: 'Belçika', dial: '+32', flag: '🇧🇪', mask: '000 00 00 00', placeholder: 'XXX XX XX XX', digits: 9 },
  { code: 'AT', name: 'Avusturya', dial: '+43', flag: '🇦🇹', mask: '0000 000000', placeholder: 'XXXX XXXXXX', digits: 10 },
  { code: 'CH', name: 'İsviçre', dial: '+41', flag: '🇨🇭', mask: '00 000 00 00', placeholder: 'XX XXX XX XX', digits: 9 },
  { code: 'SE', name: 'İsveç', dial: '+46', flag: '🇸🇪', mask: '000-000 00 00', placeholder: 'XXX-XXX XX XX', digits: 9 },
  { code: 'NO', name: 'Norveç', dial: '+47', flag: '🇳🇴', mask: '000 00 000', placeholder: 'XXX XX XXX', digits: 8 },
  { code: 'DK', name: 'Danimarka', dial: '+45', flag: '🇩🇰', mask: '00 00 00 00', placeholder: 'XX XX XX XX', digits: 8 },
  { code: 'PL', name: 'Polonya', dial: '+48', flag: '🇵🇱', mask: '000 000 000', placeholder: 'XXX XXX XXX', digits: 9 },
  { code: 'GR', name: 'Yunanistan', dial: '+30', flag: '🇬🇷', mask: '000 000 0000', placeholder: 'XXX XXX XXXX', digits: 10 },
  { code: 'BG', name: 'Bulgaristan', dial: '+359', flag: '🇧🇬', mask: '00 000 000', placeholder: 'XX XXX XXX', digits: 8 },
  { code: 'RO', name: 'Romanya', dial: '+40', flag: '🇷🇴', mask: '000 000 000', placeholder: 'XXX XXX XXX', digits: 9 },
  { code: 'AE', name: 'Birleşik Arap Emirlikleri', dial: '+971', flag: '🇦🇪', mask: '00 000 0000', placeholder: 'XX XXX XXXX', digits: 9 },
  { code: 'SA', name: 'Suudi Arabistan', dial: '+966', flag: '🇸🇦', mask: '00 000 0000', placeholder: 'XX XXX XXXX', digits: 9 },
  { code: 'QA', name: 'Katar', dial: '+974', flag: '🇶🇦', mask: '0000 0000', placeholder: 'XXXX XXXX', digits: 8 },
  { code: 'KKTC', name: 'Kuzey Kıbrıs', dial: '+90', flag: '🇹🇷', mask: '(000) 000 00 00', placeholder: '(5XX) XXX XX XX', digits: 10 },
  { code: 'CA', name: 'Kanada', dial: '+1', flag: '🇨🇦', mask: '(000) 000-0000', placeholder: '(XXX) XXX-XXXX', digits: 10 },
  { code: 'CN', name: 'Çin', dial: '+86', flag: '🇨🇳', mask: '000 0000 0000', placeholder: 'XXX XXXX XXXX', digits: 11 },
  { code: 'JP', name: 'Japonya', dial: '+81', flag: '🇯🇵', mask: '00 0000 0000', placeholder: 'XX XXXX XXXX', digits: 10 },
  { code: 'KR', name: 'Güney Kore', dial: '+82', flag: '🇰🇷', mask: '00 0000 0000', placeholder: 'XX XXXX XXXX', digits: 10 },
  { code: 'IN', name: 'Hindistan', dial: '+91', flag: '🇮🇳', mask: '00000 00000', placeholder: 'XXXXX XXXXX', digits: 10 },
  { code: 'BR', name: 'Brezilya', dial: '+55', flag: '🇧🇷', mask: '(00) 00000-0000', placeholder: '(XX) XXXXX-XXXX', digits: 11 },
  { code: 'AU', name: 'Avustralya', dial: '+61', flag: '🇦🇺', mask: '0000 000 000', placeholder: 'XXXX XXX XXX', digits: 9 }
];

// ============================================================================
// 2. MATEMATİKSEL DOĞRULAMA FONKSİYONLARI
// ============================================================================

/**
 * T.C. Kimlik Numarası Algoritma Doğrulaması (Resmi Luhn varyantı)
 * @param {string} val
 * @returns {boolean}
 */
export function validateTCKN(val) {
  const digits = String(val).replace(/\D/g, '');
  if (digits.length !== 11) return false;
  if (digits[0] === '0') return false;

  const d = digits.split('').map(Number);

  // Kural 1: 1, 3, 5, 7, 9. haneler toplamının 7 katından 2, 4, 6, 8. haneler çıkarıldığında mod 10, 10. haneyi vermeli
  const oddSum = d[0] + d[2] + d[4] + d[6] + d[8];
  const evenSum = d[1] + d[3] + d[5] + d[7];
  const digit10 = ((oddSum * 7) - evenSum) % 10;
  const validDigit10 = (digit10 + 10) % 10;
  if (validDigit10 !== d[9]) return false;

  // Kural 2: İlk 10 hanenin toplamının mod 10'u 11. haneyi vermeli
  const sumFirst10 = d.slice(0, 10).reduce((a, b) => a + b, 0);
  if ((sumFirst10 % 10) !== d[10]) return false;

  return true;
}

/**
 * Vergi Kimlik Numarası (VKN) Algoritma Doğrulaması (Gelir İdaresi Başkanlığı)
 * @param {string} val
 * @returns {boolean}
 */
export function validateVKN(val) {
  const digits = String(val).replace(/\D/g, '');
  if (digits.length !== 10) return false;

  const d = digits.split('').map(Number);
  let sum = 0;

  for (let i = 0; i < 9; i++) {
    const v1 = (d[i] + (9 - i)) % 10;
    let v2 = 0;
    if (v1 !== 0) {
      v2 = (v1 * Math.pow(2, 9 - i)) % 9;
      if (v2 === 0) v2 = 9;
    }
    sum += v2;
  }

  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === d[9];
}

/**
 * IBAN Mod-97 Doğrulaması (ISO 13616)
 * @param {string} val
 * @returns {boolean}
 */
export function validateIBAN(val) {
  const clean = String(val).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (clean.length !== 26) return false;
  if (!clean.startsWith('TR')) return false;

  // İlk 4 karakteri sona taşı
  const rearranged = clean.slice(4) + clean.slice(0, 4);

  // Harfleri sayılara dönüştür (A=10, ..., Z=35; T=29, R=27)
  let numericString = '';
  for (let i = 0; i < rearranged.length; i++) {
    const char = rearranged[i];
    const code = char.charCodeAt(0);
    if (code >= 65 && code <= 90) {
      numericString += (code - 55).toString();
    } else {
      numericString += char;
    }
  }

  try {
    return BigInt(numericString) % 97n === 1n;
  } catch {
    return false;
  }
}

/**
 * IBAN'dan Banka Tespiti
 * @param {string} val
 * @returns {Object|null}
 */
export function detectBankFromIBAN(val) {
  const clean = String(val).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
  if (!clean.startsWith('TR') || clean.length < 9) return null;

  // TR'den sonraki 2 hane checksum, sonraki 5 hane banka kodu
  const bankCode = clean.slice(4, 9);
  return TURKISH_BANKS[bankCode] || null;
}

/**
 * Kredi Kartı Luhn Algoritması
 * @param {string} val
 * @returns {boolean}
 */
export function validateCardLuhn(val) {
  const clean = String(val).replace(/\D/g, '');
  if (clean.length < 13 || clean.length > 19) return false;

  let sum = 0;
  let shouldDouble = false;

  for (let i = clean.length - 1; i >= 0; i--) {
    let digit = parseInt(clean.charAt(i), 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

/**
 * Kredi Kartı Tipi Tespiti (Troy, Visa, Mastercard, Amex)
 * @param {string} val
 * @returns {Object|null}
 */
export function detectCardType(val) {
  const clean = String(val).replace(/\D/g, '');
  if (clean.startsWith('9792')) {
    return { 
      name: 'Troy', 
      icon: `<svg width="18" height="11" viewBox="0 0 28 16"><text x="1" y="12" font-family="-apple-system, sans-serif" font-weight="900" font-size="12" fill="#0083ca" letter-spacing="-0.5">troy</text></svg>`, 
      color: '#0083ca', 
      bg: 'rgba(0, 131, 202, 0.12)' 
    };
  }
  if (clean.startsWith('4')) {
    return { 
      name: 'Visa', 
      icon: `<svg width="18" height="11" viewBox="0 0 32 16" fill="#1a1f71"><path d="M13.2 2.5L9.6 13.5H7L4.4 5.2c-.2-.6-.3-.8-.7-1-.7-.4-1.8-.7-2.7-.9l.1-.4h4.7c.6 0 1.1.4 1.2 1.1L8.2 10l2.3-7.5h2.7zm9.6 7.4c0-2.8-3.9-3-3.9-4.2 0-.4.4-.8 1.2-.9.4 0 1.5-.1 2.8.5l.5-2.3c-.7-.3-1.6-.5-2.7-.5-2.8 0-4.8 1.5-4.8 3.7 0 1.6 1.4 2.5 2.5 3 1.1.6 1.5.9 1.5 1.5 0 .8-1 1.2-1.9 1.2-1.3 0-2-.2-3.1-.7l-.5 2.4c.7.3 1.9.6 3.2.6 3 0 5-1.5 5-3.8zM28 13.5h2.4L28.3 2.5h-2.2c-.5 0-.9.3-1.1.7L21 13.5h2.7l.5-1.5h3.3l.5 1.5zm-2.8-3.7l1.4-3.8.8 3.8h-2.2zM18 2.5l-2.1 11h-2.5l2.1-11H18z"/></svg>`, 
      color: '#1a1f71', 
      bg: 'rgba(26, 31, 113, 0.12)' 
    };
  }
  if (/^(5[1-5]|222[1-9]|22[3-9]\d|2[3-6]\d{2}|27[01]\d|2720)/.test(clean)) {
    return { 
      name: 'Mastercard', 
      icon: `<svg width="18" height="11" viewBox="0 0 24 16"><circle cx="8" cy="8" r="6" fill="#eb001b"/><circle cx="16" cy="8" r="6" fill="#f79e1b" fill-opacity="0.85"/></svg>`, 
      color: '#eb001b', 
      bg: 'rgba(235, 0, 27, 0.12)' 
    };
  }
  if (/^3[47]/.test(clean)) {
    return { 
      name: 'Amex', 
      icon: `<svg width="18" height="11" viewBox="0 0 24 16" fill="#006fcf"><rect width="24" height="16" rx="2"/><text x="2" y="11" font-family="sans-serif" font-weight="800" font-size="7" fill="#ffffff">AMEX</text></svg>`, 
      color: '#006fcf', 
      bg: 'rgba(0, 111, 207, 0.12)' 
    };
  }
  return null;
}

/**
 * Türkiye Araç Plaka Doğrulaması
 * @param {string} val
 * @returns {boolean}
 */
export function validatePlate(val) {
  const clean = String(val).trim().toUpperCase();
  // 34 ABC 123, 06 A 1234, 35 AB 1234, 34 XXX 99, 06 AAA 01
  const plateRegex = /^(0[1-9]|[1-7][0-9]|8[01])\s*([A-Z]{1,3})\s*(\d{2,4})$/;
  const match = clean.match(plateRegex);
  if (!match) return false;

  const ilKodu = parseInt(match[1], 10);
  return ilKodu >= 1 && ilKodu <= 81;
}

// ============================================================================
// 3. ÇEKİRDEK MASKE SINIFI (DIJITAL MASK ENGINE)
// ============================================================================

export class DijitalMask {
  /**
   * @param {HTMLInputElement|string} target
   * @param {Object} options
   */
  constructor(target, options = {}) {
    this.input = typeof target === 'string' ? document.querySelector(target) : target;
    if (!this.input || !this.input.tagName || this.input.tagName.toLowerCase() !== 'input') {
      throw new Error('[DijitalMask] Geçerli bir HTMLInputElement belirtilmelidir.');
    }

    // HTML Veri Niteliklerinden (data-mask-*) Ayarları Oku
    const dataset = this.input.dataset;
    this.options = Object.assign(
      {
        mask: dataset.mask || 'custom', // tckn, vkn, iban, phone, currency, plate, card, card-expiry, card-cvv, postal, custom
        pattern: dataset.maskPattern || '', // Özel şablon örn: 'AA-000-AA' (0: rakam, A: harf, *: herhangi)
        currency: dataset.maskCurrency || 'TRY', // TRY, USD, EUR, GBP
        precision: dataset.maskPrecision !== undefined ? parseInt(dataset.maskPrecision, 10) : 2,
        currencyMode: dataset.maskCurrencyMode || 'natural', // 'natural' veya 'cents'
        country: dataset.maskCountry || 'TR', // Telefon için varsayılan ülke kodu
        showCountrySelect: dataset.maskCountrySelect !== 'false', // Telefon alan kodu açılır listesi gösterilsin mi
        phoneFormat: dataset.maskPhoneFormat || '+90', // '+90' veya '0'
        allowZeroFirst: dataset.maskAllowZero === 'true' || false, // TCKN için ilk hanede 0'a izin verilsin mi
        showBadge: dataset.maskBadge !== 'false', // Banka / Kart tipi rozeti gösterilsin mi
        showStatus: dataset.maskStatus !== 'false', // Geçerli/geçersiz onay ikonu
        showFeedback: dataset.maskFeedback === 'true' || false, // Alt geri bildirim metni (dm-feedback)
        autoValidate: dataset.maskValidate !== 'false', // Otomatik yeşil/kırmızı kenarlık
        syncHiddenInput: dataset.maskSyncHidden === 'true' || false, // Form submit için gizli raw input
        rawName: dataset.maskRawName || null, // Gizli inputun name özniteliği
        onValid: null,
        onInvalid: null,
        onChange: null
      },
      options
    );

    const initialCountryCode = (this.options.country || 'TR').toUpperCase();
    const initialCountry = COUNTRY_DIAL_CODES.find(c => c.code === initialCountryCode) || COUNTRY_DIAL_CODES[0];

    this.state = {
      rawValue: '',
      formattedValue: '',
      isValid: false,
      validationDetail: '',
      detectedBank: null,
      detectedCard: null,
      feedbackType: '', // 'valid', 'invalid', 'hint', ''
      country: initialCountry,
      nationalNumber: ''
    };

    this.init();
  }

  /**
   * Bileşeni Başlat
   */
  init() {
    this.buildWrapper();
    this.buildHiddenInput();

    if (this.options.mask === 'phone' && this.options.showCountrySelect) {
      this.buildCountrySelect();
    }

    this.bindEvents();

    // Varsa mevcut input değerini formatla
    if (this.input.value) {
      if (this.options.mask === 'phone') {
        this.handlePhonePaste(this.input.value);
      } else {
        this.formatAndApply(this.input.value);
      }
    } else if (this.options.mask === 'phone' && !this.input.placeholder) {
      this.input.placeholder = this.state.country?.placeholder || '(5XX) XXX XX XX';
    }
  }

  /**
   * Telefon Alan Kodu Dropdown Bileşenini Oluştur
   */
  buildCountrySelect() {
    this.wrapper.classList.add('dm-has-country-select');

    // Var olan select container'ı temizle veya oluştur
    let container = this.wrapper.querySelector('.dm-country-select');
    if (!container) {
      container = document.createElement('div');
      container.className = 'dm-country-select';
      this.wrapper.insertBefore(container, this.input);
    } else {
      container.innerHTML = '';
    }
    this.countrySelectContainer = container;

    // Seçici Butonu
    const currentCountry = this.state.country || COUNTRY_DIAL_CODES[0];
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dm-country-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.title = `${currentCountry.name} (${currentCountry.dial})`;
    btn.innerHTML = `
      <span class="dm-country-flag">${currentCountry.flag}</span>
      <span class="dm-country-dial">${currentCountry.dial}</span>
      <svg class="dm-country-arrow" viewBox="0 0 10 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path d="M1 1l4 4 4-4"/>
      </svg>
    `;
    container.appendChild(btn);

    const divider = document.createElement('div');
    divider.className = 'dm-country-divider';
    container.appendChild(divider);

    this.countryBtn = btn;
    this.countryFlagEl = btn.querySelector('.dm-country-flag');
    this.countryDialEl = btn.querySelector('.dm-country-dial');

    // Açılır Liste (Dropdown)
    const dropdown = document.createElement('div');
    dropdown.className = 'dm-country-dropdown';
    dropdown.innerHTML = `
      <div class="dm-country-search-box">
        <input type="text" class="dm-country-search" placeholder="Ülke veya alan kodu ara..." autocomplete="off">
      </div>
      <ul class="dm-country-list" role="listbox"></ul>
    `;
    container.appendChild(dropdown);
    this.countryDropdown = dropdown;
    this.countrySearchInput = dropdown.querySelector('.dm-country-search');
    this.countryList = dropdown.querySelector('.dm-country-list');

    this.renderCountryList();

    // Buton Tıklama
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      e.preventDefault();
      this.toggleCountryDropdown();
    });

    // Arama Girişi
    this.countrySearchInput.addEventListener('input', (e) => {
      const q = e.target.value.toLowerCase().trim();
      this.renderCountryList(q);
    });

    // Tuş Kontrolü
    this.countrySearchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeCountryDropdown();
        this.input.focus();
      }
    });

    // Dışarı tıklama
    this._onDocClick = (e) => {
      if (this.countrySelectContainer && !this.countrySelectContainer.contains(e.target)) {
        this.closeCountryDropdown();
      }
    };
    document.addEventListener('click', this._onDocClick);
  }

  renderCountryList(query = '') {
    if (!this.countryList) return;
    this.countryList.innerHTML = '';

    const filtered = COUNTRY_DIAL_CODES.filter((c) => {
      if (!query) return true;
      return (
        c.name.toLowerCase().includes(query) ||
        c.dial.toLowerCase().includes(query) ||
        c.code.toLowerCase().includes(query)
      );
    });

    if (filtered.length === 0) {
      const empty = document.createElement('li');
      empty.className = 'dm-country-empty';
      empty.style.padding = '8px 12px';
      empty.style.fontSize = '12px';
      empty.style.color = 'var(--dm-text-muted)';
      empty.textContent = 'Sonuç bulunamadı';
      this.countryList.appendChild(empty);
      return;
    }

    filtered.forEach((c) => {
      const item = document.createElement('li');
      item.className = 'dm-country-item';
      if (this.state.country && this.state.country.code === c.code) {
        item.classList.add('is-selected');
      }
      item.setAttribute('role', 'option');
      item.innerHTML = `
        <div class="dm-country-item-left">
          <span class="dm-country-flag">${c.flag}</span>
          <span class="dm-country-item-name">${this.escapeHtml(c.name)}</span>
        </div>
        <span class="dm-country-item-dial">${c.dial}</span>
      `;
      item.addEventListener('click', (e) => {
        e.stopPropagation();
        this.setCountry(c.code);
        this.input.focus();
      });
      this.countryList.appendChild(item);
    });
  }

  toggleCountryDropdown() {
    if (this.countrySelectContainer && this.countrySelectContainer.classList.contains('is-open')) {
      this.closeCountryDropdown();
    } else {
      this.openCountryDropdown();
    }
  }

  openCountryDropdown() {
    if (!this.countrySelectContainer) return;
    this.countrySelectContainer.classList.add('is-open');
    this.countryBtn.setAttribute('aria-expanded', 'true');
    if (this.countrySearchInput) {
      this.countrySearchInput.value = '';
      this.renderCountryList();
      setTimeout(() => this.countrySearchInput.focus(), 50);
    }
  }

  closeCountryDropdown() {
    if (!this.countrySelectContainer) return;
    this.countrySelectContainer.classList.remove('is-open');
    this.countryBtn.setAttribute('aria-expanded', 'false');
  }

  setCountry(code, reformat = true) {
    const found = COUNTRY_DIAL_CODES.find((c) => c.code.toUpperCase() === code.toUpperCase());
    if (!found) return;

    this.state.country = found;
    if (this.countryFlagEl) this.countryFlagEl.textContent = found.flag;
    if (this.countryDialEl) this.countryDialEl.textContent = found.dial;
    if (this.countryBtn) this.countryBtn.title = `${found.name} (${found.dial})`;
    this.input.placeholder = found.placeholder || '(5XX) XXX XX XX';
    this.closeCountryDropdown();

    if (reformat) {
      this.formatAndApply(this.state.nationalNumber || this.input.value);
      this.dispatchEvents();
    }
  }

  /**
   * Rozet, İkonlar ve Geri Bildirim için Wrapper Oluştur
   */
  buildWrapper() {
    if (this.input.closest('.dm-wrapper')) {
      this.wrapper = this.input.closest('.dm-wrapper');
    } else {
      this.wrapper = document.createElement('div');
      this.wrapper.className = 'dm-wrapper';
      this.input.parentNode.insertBefore(this.wrapper, this.input);
      this.wrapper.appendChild(this.input);
    }

    this.input.classList.add('dm-input');

    // Badge ve Durum Konteyneri
    let existingBadge = this.wrapper.querySelector('.dm-badge-container');
    if (!existingBadge) {
      this.badgeContainer = document.createElement('div');
      this.badgeContainer.className = 'dm-badge-container';
      this.wrapper.appendChild(this.badgeContainer);
    } else {
      this.badgeContainer = existingBadge;
    }

    // Feedback Elementi (Geri bildirim alanı)
    if (this.options.showFeedback) {
      let existingFeedback = this.wrapper.parentNode.querySelector(`.dm-feedback[data-for="${this.input.id || ''}"]`);
      if (!existingFeedback) {
        this.feedbackEl = document.createElement('div');
        this.feedbackEl.className = 'dm-feedback';
        if (this.input.id) this.feedbackEl.dataset.for = this.input.id;
        this.wrapper.parentNode.insertBefore(this.feedbackEl, this.wrapper.nextSibling);
      } else {
        this.feedbackEl = existingFeedback;
      }
    }
  }

  /**
   * Form / HTMX için Gizli Raw Input Senkronizasyonu
   */
  buildHiddenInput() {
    if (!this.options.syncHiddenInput) return;

    const rawName = this.options.rawName || (this.input.name ? `${this.input.name}_raw` : null);
    if (!rawName) return;

    let existing = this.wrapper.querySelector(`input[type="hidden"][name="${rawName}"]`);
    if (!existing) {
      this.hiddenInput = document.createElement('input');
      this.hiddenInput.type = 'hidden';
      this.hiddenInput.name = rawName;
      this.wrapper.appendChild(this.hiddenInput);
    } else {
      this.hiddenInput = existing;
    }
  }

  /**
   * Olay Dinleyicileri
   */
  bindEvents() {
    this._onInput = (e) => {
      this.handleInput(e);
    };

    this._onPaste = (e) => {
      e.preventDefault();
      const text = (e.clipboardData || window.clipboardData).getData('text');
      if (this.options.mask === 'phone') {
        this.handlePhonePaste(text);
      } else {
        this.formatAndApply(text);
      }
      this.dispatchEvents();
    };

    this._onKeydown = (e) => {
      this.handleKeydown(e);
    };

    this.input.addEventListener('input', this._onInput);
    this.input.addEventListener('paste', this._onPaste);
    this.input.addEventListener('keydown', this._onKeydown);
  }

  /**
   * Telefon Numarası Yapıştırma Yönetimi (Akıllı Alan Kodu Tespiti ve Format Temizliği)
   */
  handlePhonePaste(text) {
    if (!text) return;
    let str = String(text).trim();

    // 1. + ile başlıyorsa veya uluslararası kod içeriyorsa ülke tespiti yap
    if (str.startsWith('+')) {
      // Uzun dial kodlarına göre sırala (+994 önce, sonra +90 vb.)
      const sorted = [...COUNTRY_DIAL_CODES].sort((a, b) => b.dial.length - a.dial.length);
      const matched = sorted.find((c) => str.startsWith(c.dial));
      if (matched) {
        this.setCountry(matched.code, false);
        str = str.slice(matched.dial.length);
      }
    } else if (this.state.country && (this.state.country.code === 'TR' || this.state.country.code === 'KKTC')) {
      // Türkiye için: eğer 90 ile başlıyorsa ve 12 haneyse (90 533 ...)
      const cleanDigits = str.replace(/\D/g, '');
      if (cleanDigits.startsWith('90') && cleanDigits.length >= 12) {
        str = cleanDigits.slice(2);
      } else if (cleanDigits.startsWith('0') && cleanDigits.length >= 11) {
        str = cleanDigits.slice(1);
      }
    }

    const digits = str.replace(/\D/g, '');
    this.formatAndApply(digits);
  }

  /**
   * Özel Tuş Yönetimi (TCKN 0 ile başlama engeli ve Akıllı Backspace)
   */
  handleKeydown(e) {
    // 1. TCKN İlk Hanede '0' Engeli
    if (this.options.mask === 'tckn' && !this.options.allowZeroFirst) {
      const cursor = this.input.selectionStart;
      const isStart = cursor === 0;
      if (e.key === '0' && isStart && (this.state.rawValue.length === 0 || this.input.selectionEnd > 0)) {
        e.preventDefault();
        this.showTemporaryWarning('T.C. Kimlik No 0 ile başlayamaz');
        return;
      }
    }

    // 2. Akıllı Backspace (Ayrıcı karakterin üzerinden zıplama)
    if (e.key === 'Backspace') {
      const cursor = this.input.selectionStart;
      if (cursor > 0 && this.input.selectionEnd === cursor) {
        const charBefore = this.input.value[cursor - 1];
        if (!this.isRawChar(charBefore, this.options.mask)) {
          e.preventDefault();
          // Ayırıcıdan önceki gerçek karakteri sil
          let targetCursor = cursor - 1;
          while (targetCursor > 0 && !this.isRawChar(this.input.value[targetCursor - 1], this.options.mask)) {
            targetCursor--;
          }
          if (targetCursor > 0) {
            const val = this.input.value;
            const newVal = val.slice(0, targetCursor - 1) + val.slice(cursor);
            this.input.value = newVal;
            this.handleInput(e);
            this.input.setSelectionRange(targetCursor - 1, targetCursor - 1);
          }
        }
      }
    }
  }

  /**
   * Geçici Uyarı Gösterimi
   */
  showTemporaryWarning(msg) {
    if (this.feedbackEl) {
      this.feedbackEl.className = 'dm-feedback dm-feedback-invalid';
      this.feedbackEl.textContent = msg;
      clearTimeout(this._warnTimeout);
      this._warnTimeout = setTimeout(() => {
        this.renderFeedback();
      }, 2500);
    }
  }

  /**
   * Canlı Input Olayı ve İmleç Pozisyon Koruma
   */
  handleInput(e) {
    const el = this.input;
    const oldVal = el.value;
    const oldCursor = el.selectionStart || 0;

    // İmleçten önceki ham karakter sayısını tespit et
    const rawBeforeCursor = this.stripNonMaskChars(oldVal.slice(0, oldCursor), this.options.mask).length;

    // Yeni değeri formatla
    this.formatAndApply(oldVal);

    // Yeni imleç konumunu hesapla
    let newCursor = 0;
    let countedRaw = 0;
    const newFormatted = this.input.value;

    for (let i = 0; i < newFormatted.length; i++) {
      if (countedRaw >= rawBeforeCursor) {
        newCursor = i;
        break;
      }
      if (this.isRawChar(newFormatted[i], this.options.mask)) {
        countedRaw++;
      }
      newCursor = i + 1;
    }

    el.setSelectionRange(newCursor, newCursor);
    this.dispatchEvents();
  }

  /**
   * Formatla ve State Güncelle
   */
  formatAndApply(val) {
    const maskType = this.options.mask;
    let formatted = '';
    let raw = '';
    let isValid = false;
    let validationDetail = '';
    let feedbackType = '';

    switch (maskType) {
      case 'tckn': {
        raw = String(val).replace(/\D/g, '');
        // İlk hane sıfır olamaz kuralı
        if (!this.options.allowZeroFirst && raw.startsWith('0')) {
          raw = raw.replace(/^0+/, '');
        }
        raw = raw.slice(0, 11);
        formatted = raw; // Boşluksuz saf 11 hane

        if (raw.length === 11) {
          isValid = validateTCKN(raw);
          validationDetail = isValid ? 'T.C. Kimlik Numarası Doğrulandı' : 'Geçersiz TCKN (Algoritma Tutarsız)';
          feedbackType = isValid ? 'valid' : 'invalid';
        } else if (raw.length > 0) {
          isValid = false;
          validationDetail = `${11 - raw.length} hane kaldı`;
          feedbackType = 'hint';
        }
        break;
      }

      case 'vkn': {
        raw = String(val).replace(/\D/g, '').slice(0, 10);
        formatted = raw; // Boşluksuz saf 10 hane

        if (raw.length === 10) {
          isValid = validateVKN(raw);
          validationDetail = isValid ? 'Vergi Kimlik No Doğrulandı' : 'Geçersiz VKN (GİB Algoritması Tutarsız)';
          feedbackType = isValid ? 'valid' : 'invalid';
        } else if (raw.length > 0) {
          isValid = false;
          validationDetail = `${10 - raw.length} hane kaldı`;
          feedbackType = 'hint';
        }
        break;
      }

      case 'iban': {
        raw = String(val).replace(/[^A-Za-z0-9]/g, '').toUpperCase();
        if (raw && !raw.startsWith('TR')) {
          raw = 'TR' + raw.replace(/TR/g, '');
        }
        raw = raw.slice(0, 26);
        formatted = this.formatIBANString(raw);

        // Banka Tespiti
        this.state.detectedBank = detectBankFromIBAN(raw);

        if (raw.length === 26) {
          isValid = validateIBAN(raw);
          validationDetail = isValid
            ? `${this.state.detectedBank?.name || 'IBAN'} Doğrulandı`
            : 'Geçersiz IBAN Sağlaması (Mod-97 Hatalı)';
          feedbackType = isValid ? 'valid' : 'invalid';
        } else if (raw.length > 2) {
          isValid = false;
          validationDetail = `${26 - raw.length} hane kaldı` + (this.state.detectedBank ? ` (${this.state.detectedBank.shortName})` : '');
          feedbackType = 'hint';
        }
        break;
      }

      case 'phone': {
        const country = this.state.country || COUNTRY_DIAL_CODES[0];
        let digits = String(val).replace(/\D/g, '');

        // Türkiye için baştaki 90 veya 0 temizliği (yapıştırma veya elle yazma sırasında)
        if (country.code === 'TR' || country.code === 'KKTC') {
          if (digits.startsWith('90') && digits.length > 10) {
            digits = digits.slice(2);
          }
          if (digits.startsWith('0') && digits.length > 10) {
            digits = digits.slice(1);
          }
        }

        const maxDigits = country.digits || 10;
        digits = digits.slice(0, maxDigits);
        this.state.nationalNumber = digits;

        if (country.code === 'TR' || country.code === 'KKTC') {
          const res = this.formatTRPhone(digits);
          formatted = res.formatted;
          isValid = res.isValid;
          validationDetail = res.validationDetail;
        } else {
          // Uluslararası şablon formatı uygula
          const pat = country.mask || '';
          formatted = pat ? this.formatPattern(digits, pat) : digits;
          isValid = digits.length === maxDigits;
          validationDetail = isValid
            ? `${country.name} Numarası Geçerli`
            : (digits.length > 0 ? `${maxDigits - digits.length} hane kaldı` : '');
        }

        // raw: E.164 uluslararası tam numara (örn: +905333790008)
        raw = digits.length > 0 ? `${country.dial}${digits}` : '';
        feedbackType = isValid ? 'valid' : (digits.length > 0 ? 'hint' : '');
        break;
      }

      case 'currency': {
        const res = this.formatCurrency(val, this.options.currency, this.options.precision, this.options.currencyMode);
        raw = res.raw;
        formatted = res.formatted;
        isValid = !isNaN(parseFloat(raw)) && parseFloat(raw) > 0;
        validationDetail = isValid ? `${raw} ${this.options.currency}` : '';
        feedbackType = isValid ? 'valid' : '';
        break;
      }

      case 'plate': {
        raw = String(val).replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 9);
        formatted = this.formatPlateString(raw);
        isValid = validatePlate(formatted);
        validationDetail = isValid ? 'Araç Plakası Geçerli' : (raw.length >= 7 ? 'Geçersiz Plaka Formatı' : 'Plaka Formatı: 34 ABC 123');
        feedbackType = isValid ? 'valid' : (raw.length >= 7 ? 'invalid' : 'hint');
        break;
      }

      case 'card': {
        raw = String(val).replace(/\D/g, '').slice(0, 16);
        formatted = this.formatPattern(raw, '0000 0000 0000 0000');
        this.state.detectedCard = detectCardType(raw);
        isValid = raw.length === 16 && validateCardLuhn(raw);
        validationDetail = isValid
          ? `${this.state.detectedCard?.name || 'Kart'} Doğrulandı`
          : (raw.length === 16 ? 'Geçersiz Kart Numarası (Luhn Hatası)' : `${16 - raw.length} hane kaldı`);
        feedbackType = isValid ? 'valid' : (raw.length === 16 ? 'invalid' : 'hint');
        break;
      }

      case 'card-expiry': {
        raw = String(val).replace(/\D/g, '').slice(0, 4);
        formatted = this.formatPattern(raw, '00/00');
        if (raw.length === 4) {
          const month = parseInt(raw.slice(0, 2), 10);
          isValid = month >= 1 && month <= 12;
          validationDetail = isValid ? 'Son Kullanma Tarihi Geçerli' : 'Geçersiz Ay (01-12)';
          feedbackType = isValid ? 'valid' : 'invalid';
        }
        break;
      }

      case 'card-cvv': {
        raw = String(val).replace(/\D/g, '').slice(0, 4);
        formatted = raw;
        isValid = raw.length >= 3;
        validationDetail = isValid ? 'CVV Geçerli' : '';
        feedbackType = isValid ? 'valid' : '';
        break;
      }

      case 'postal': {
        raw = String(val).replace(/\D/g, '').slice(0, 5);
        formatted = raw;
        isValid = raw.length === 5;
        validationDetail = isValid ? 'Posta Kodu' : '';
        feedbackType = isValid ? 'valid' : '';
        break;
      }

      case 'custom':
      default: {
        const pat = this.options.pattern || '';
        raw = val;
        formatted = pat ? this.formatPattern(val, pat) : val;
        isValid = true;
        validationDetail = '';
        feedbackType = '';
        break;
      }
    }

    this.state.rawValue = raw;
    this.state.formattedValue = formatted;
    this.state.isValid = isValid;
    this.state.validationDetail = validationDetail;
    this.state.feedbackType = feedbackType;

    this.input.value = formatted;
    this.input.dataset.rawValue = raw;

    // Gizli inputu senkronize et
    if (this.hiddenInput) {
      this.hiddenInput.value = raw;
    }

    this.renderUIState();
  }

  /**
   * Arayüz Rozet ve Doğrulama Durumunu Render Et
   */
  renderUIState() {
    this.badgeContainer.innerHTML = '';
    let hasBadge = false;
    let hasStatus = false;

    // 1. Banka Rozeti (IBAN)
    if (this.options.showBadge && this.state.detectedBank && this.options.mask === 'iban') {
      const bank = this.state.detectedBank;
      const badge = document.createElement('span');
      badge.className = 'dm-badge dm-badge-bank';
      badge.title = bank.name;
      badge.style.setProperty('--dm-badge-brand-color', bank.color);
      badge.style.setProperty('--dm-badge-brand-bg', bank.bg);

      let customLogo = this.options.bankLogos && this.options.bankLogos[bank.code];
      let iconHtml = '';
      if (customLogo) {
        if (customLogo.startsWith('http') || customLogo.startsWith('/') || customLogo.includes('.')) {
          iconHtml = `<img src="${this.escapeHtml(customLogo)}" class="dm-badge-img" alt="${this.escapeHtml(bank.shortName)}">`;
        } else {
          iconHtml = customLogo;
        }
      } else {
        iconHtml = bank.icon;
      }

      badge.innerHTML = `<span class="dm-badge-icon">${iconHtml}</span>`;
      this.badgeContainer.appendChild(badge);
      hasBadge = true;
    }

    // 2. Kart Tipi Rozeti (Kredi Kartı)
    if (this.options.showBadge && this.state.detectedCard && this.options.mask === 'card') {
      const card = this.state.detectedCard;
      const badge = document.createElement('span');
      badge.className = 'dm-badge dm-badge-card';
      badge.title = card.name;
      badge.style.setProperty('--dm-badge-brand-color', card.color);
      badge.style.setProperty('--dm-badge-brand-bg', card.bg);
      badge.innerHTML = `<span class="dm-badge-icon">${card.icon}</span>`;
      this.badgeContainer.appendChild(badge);
      hasBadge = true;
    }

    // 3. Doğrulama Onay/Hata İkonu
    if (this.options.showStatus && this.state.rawValue.length > 0) {
      const isFull = this.isLengthFull();
      if (this.state.isValid || isFull) {
        const statusIcon = document.createElement('span');
        statusIcon.className = `dm-status-icon ${this.state.isValid ? 'dm-status-valid' : 'dm-status-invalid'}`;
        statusIcon.innerHTML = this.state.isValid
          ? `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>`
          : `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
        
        this.badgeContainer.appendChild(statusIcon);
        hasStatus = true;
      }
    }

    // Wrapper Padding Sınıfları
    this.wrapper.classList.toggle('dm-has-badge', hasBadge);
    this.wrapper.classList.toggle('dm-has-status', hasStatus);

    // Otomatik Doğrulama Kenarlık Sınıfları
    if (this.options.autoValidate) {
      const isFull = this.isLengthFull();
      if (this.state.rawValue.length === 0) {
        this.input.classList.remove('dm-valid', 'dm-invalid');
        this.wrapper.classList.remove('dm-is-valid', 'dm-is-invalid');
      } else if (this.state.isValid) {
        this.input.classList.add('dm-valid');
        this.input.classList.remove('dm-invalid');
        this.wrapper.classList.add('dm-is-valid');
        this.wrapper.classList.remove('dm-is-invalid');
      } else if (isFull) {
        this.input.classList.add('dm-invalid');
        this.input.classList.remove('dm-valid');
        this.wrapper.classList.add('dm-is-invalid');
        this.wrapper.classList.remove('dm-is-valid');
      } else {
        this.input.classList.remove('dm-valid', 'dm-invalid');
        this.wrapper.classList.remove('dm-is-valid', 'dm-is-invalid');
      }
    }

    // 4. Feedback (Yardımcı Metin) Güncellemesi
    this.renderFeedback();
  }

  /**
   * Tamamlanma Durumunu Kontrol Et
   */
  isLengthFull() {
    const rawLen = this.state.rawValue.length;
    switch (this.options.mask) {
      case 'tckn': return rawLen === 11;
      case 'vkn': return rawLen === 10;
      case 'iban': return rawLen === 26;
      case 'card': return rawLen === 16;
      case 'card-expiry': return rawLen === 4;
      case 'phone': {
        const targetDigits = this.state.country?.digits || 10;
        return (this.state.nationalNumber || '').length >= targetDigits;
      }
      case 'plate': return rawLen >= 7;
      default: return false;
    }
  }

  /**
   * Feedback Elementini Güncelle
   */
  renderFeedback() {
    if (!this.feedbackEl) return;

    const { validationDetail, feedbackType, rawValue } = this.state;

    if (!rawValue || !validationDetail) {
      this.feedbackEl.textContent = '';
      this.feedbackEl.className = 'dm-feedback';
      return;
    }

    this.feedbackEl.className = `dm-feedback dm-feedback-${feedbackType}`;
    this.feedbackEl.textContent = validationDetail;
  }

  /**
   * Olayları Fırlat
   */
  dispatchEvents() {
    const detail = {
      value: this.state.formattedValue,
      rawValue: this.state.rawValue,
      isValid: this.state.isValid,
      mask: this.options.mask,
      country: this.state.country,
      nationalNumber: this.state.nationalNumber,
      bank: this.state.detectedBank,
      card: this.state.detectedCard,
      detail: this.state.validationDetail
    };

    this.dispatch('dm:change', detail);
    if (typeof this.options.onChange === 'function') {
      this.options.onChange(detail);
    }

    if (this.state.isValid) {
      this.dispatch('dm:valid', detail);
      if (typeof this.options.onValid === 'function') {
        this.options.onValid(detail);
      }
    } else if (this.isLengthFull()) {
      this.dispatch('dm:invalid', detail);
      if (typeof this.options.onInvalid === 'function') {
        this.options.onInvalid(detail);
      }
    }
  }

  // ==========================================================================
  // FORMATLAMA YARDIMCILARI
  // ==========================================================================

  /**
   * Şablon Formatlama (0: Rakam, A: Harf, *: Her Şey)
   */
  formatPattern(val, pattern) {
    const raw = String(val).replace(/[^A-Za-z0-9]/g, '');
    let formatted = '';
    let rawIdx = 0;

    for (let i = 0; i < pattern.length && rawIdx < raw.length; i++) {
      const p = pattern[i];
      if (p === '0') {
        while (rawIdx < raw.length && !/\d/.test(raw[rawIdx])) rawIdx++;
        if (rawIdx < raw.length) formatted += raw[rawIdx++];
      } else if (p === 'A') {
        while (rawIdx < raw.length && !/[A-Za-z]/.test(raw[rawIdx])) rawIdx++;
        if (rawIdx < raw.length) formatted += raw[rawIdx++].toUpperCase();
      } else if (p === '*') {
        formatted += raw[rawIdx++];
      } else {
        formatted += p;
        if (raw[rawIdx] === p) rawIdx++;
      }
    }

    return formatted;
  }

  /**
   * IBAN Formatlama (TR00 0000 0000 0000 0000 00)
   */
  formatIBANString(raw) {
    let res = '';
    for (let i = 0; i < raw.length; i++) {
      if (i > 0 && (i === 2 || (i > 2 && (i - 2) % 4 === 0))) {
        res += ' ';
      }
      res += raw[i];
    }
    return res;
  }

  /**
   * Türkiye Ulusal Telefon Formatı (Input içinde sadece ulusal numara tutulur)
   */
  formatTRPhone(digits) {
    // 444 Çağrı Merkezleri (7 Hane)
    if (digits.startsWith('444')) {
      const clean = digits.slice(0, 7);
      let formatted = '444';
      if (clean.length > 3) formatted += ' ' + clean.slice(3, 5);
      if (clean.length >= 5) formatted += ' ' + clean.slice(5, 7);
      const isValid = clean.length === 7;
      return {
        formatted: formatted.trim(),
        isValid,
        validationDetail: isValid ? 'Geçerli 444 Çağrı Merkezi' : `${7 - clean.length} hane kaldı`
      };
    }

    // 850 Kurumsal Hatlar (10 hane)
    if (digits.startsWith('850')) {
      const clean = digits.slice(0, 10);
      let formatted = '0850';
      if (clean.length > 3) formatted += ' ' + clean.slice(3, 6);
      if (clean.length >= 6) formatted += ' ' + clean.slice(6, 8);
      if (clean.length >= 8) formatted += ' ' + clean.slice(8, 10);
      const isValid = clean.length === 10;
      return {
        formatted: formatted.trim(),
        isValid,
        validationDetail: isValid ? 'Geçerli 0850 Kurumsal Hat' : `${10 - clean.length} hane kaldı`
      };
    }

    // Standart Cep veya Sabit Hat (10 hane)
    const clean = digits.slice(0, 10);
    const isMobile = clean.startsWith('5');
    let formatted = '';
    if (clean.length > 0) formatted += '(' + clean.slice(0, 3);
    if (clean.length >= 3) formatted += ') ';
    if (clean.length > 3) formatted += clean.slice(3, 6);
    if (clean.length >= 6) formatted += ' ';
    if (clean.length > 6) formatted += clean.slice(6, 8);
    if (clean.length >= 8) formatted += ' ';
    if (clean.length > 8) formatted += clean.slice(8, 10);

    const isValid = clean.length === 10 && (isMobile || clean.startsWith('2') || clean.startsWith('3') || clean.startsWith('4'));
    let validationDetail = '';
    if (isValid) {
      validationDetail = isMobile ? 'Geçerli Cep Telefonu' : 'Geçerli Sabit Hat';
    } else if (clean.length === 10) {
      validationDetail = 'Geçersiz Numara';
    } else if (clean.length > 0) {
      validationDetail = `${10 - clean.length} hane kaldı`;
    }

    return {
      formatted: formatted.trim(),
      isValid,
      validationDetail
    };
  }

  /**
   * Geriye Dönük Uyumluluk için Telefon Formatlayıcı
   */
  formatPhone(rawDigits, format = '+90') {
    let clean = rawDigits;
    if (clean.startsWith('90')) clean = clean.slice(2);
    if (clean.startsWith('0')) clean = clean.slice(1);
    const trRes = this.formatTRPhone(clean);
    return {
      raw: clean,
      formatted: trRes.formatted,
      type: clean.startsWith('5') ? 'mobile' : 'landline'
    };
  }

  /**
   * Türkiye Plaka Formatlama
   */
  formatPlateString(clean) {
    if (clean.length < 2) return clean;

    const il = clean.slice(0, 2);
    const rest = clean.slice(2);

    const lettersMatch = rest.match(/^[A-Z]+/);
    if (!lettersMatch) return il + (rest ? ' ' + rest : '');

    const letters = lettersMatch[0].slice(0, 3);
    const digits = rest.slice(letters.length).replace(/\D/g, '').slice(0, 4);

    let res = il + ' ' + letters;
    if (digits) res += ' ' + digits;
    return res;
  }

  /**
   * Akıllı Para & Döviz Formatlayıcı (Türkiye Standartları: 1.250.000,50 ₺)
   */
  formatCurrency(val, currency = 'TRY', precision = 2, mode = 'natural') {
    const symbols = { TRY: '₺', USD: '$', EUR: '€', GBP: '£' };
    const symbol = symbols[currency] || currency;

    let str = String(val).trim();
    if (!str) return { raw: '', formatted: '' };

    // Sadece rakam, nokta ve virgül
    let clean = str.replace(/[^0-9.,]/g, '');
    if (!clean) return { raw: '', formatted: '' };

    // Cents / ATM modu: Rakamlar sağdan sola kuruş olarak girilir
    if (mode === 'cents') {
      const digitsOnly = clean.replace(/\D/g, '');
      if (!digitsOnly) return { raw: '', formatted: '' };
      const intVal = parseInt(digitsOnly, 10);
      const floatVal = intVal / Math.pow(10, precision);
      
      const formattedNum = new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision
      }).format(floatVal);

      let formatted = `${formattedNum} ${symbol}`;
      if (currency === 'USD' || currency === 'GBP') formatted = `${symbol} ${formattedNum}`;

      return {
        raw: floatVal.toFixed(precision),
        formatted
      };
    }

    // Doğal (Natural) Mod: Kullanıcı rakam yazdıkça binlikler ayrılır, virgül basıldığında ondalığa geçilir
    let hasComma = clean.includes(',');
    let parts = clean.split(',');
    let intPartRaw = parts[0].replace(/\D/g, '');
    let decPartRaw = parts.length > 1 ? parts.slice(1).join('').replace(/\D/g, '').slice(0, precision) : '';

    if (!intPartRaw && !decPartRaw) return { raw: '', formatted: '' };

    // Tam kısmı Türk formatında (1.250.000) binliklere ayır
    let intFormatted = '';
    if (intPartRaw) {
      intFormatted = intPartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
      intFormatted = '0';
    }

    let formattedNum = intFormatted;
    if (hasComma) {
      formattedNum += ',' + decPartRaw;
    }

    let formatted = `${formattedNum} ${symbol}`;
    if (currency === 'USD' || currency === 'GBP') {
      formatted = `${symbol} ${formattedNum}`;
    }

    // Saf sayısal çıktı (1250000.50)
    let rawNum = intPartRaw || '0';
    if (decPartRaw) {
      rawNum += '.' + decPartRaw;
    }

    return {
      raw: rawNum,
      formatted
    };
  }

  // ==========================================================================
  // YARDIMCI METOTLAR
  // ==========================================================================

  stripNonMaskChars(str, maskType) {
    if (maskType === 'iban') return str.replace(/[^A-Za-z0-9]/g, '');
    if (maskType === 'plate') return str.replace(/[^A-Za-z0-9]/g, '');
    if (maskType === 'currency') return str.replace(/[^0-9.,]/g, '');
    return str.replace(/\D/g, '');
  }

  isRawChar(char, maskType) {
    if (maskType === 'iban' || maskType === 'plate') {
      return /[A-Za-z0-9]/.test(char);
    }
    if (maskType === 'currency') {
      return /[0-9.,]/.test(char);
    }
    return /\d/.test(char);
  }

  getRawValue() {
    return this.state.rawValue;
  }

  getValue() {
    return this.state.formattedValue;
  }

  isValid() {
    return this.state.isValid;
  }

  setValue(val) {
    this.formatAndApply(val);
    this.dispatchEvents();
  }

  dispatch(eventName, detail = {}) {
    const event = new CustomEvent(eventName, {
      detail,
      bubbles: true,
      cancelable: true
    });
    this.input.dispatchEvent(event);
  }

  escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  destroy() {
    this.input.removeEventListener('input', this._onInput);
    this.input.removeEventListener('paste', this._onPaste);
    this.input.removeEventListener('keydown', this._onKeydown);
    if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
    if (this.countrySelectContainer) this.countrySelectContainer.remove();
    if (this.badgeContainer) this.badgeContainer.remove();
    if (this.feedbackEl) this.feedbackEl.remove();
    if (this.hiddenInput) this.hiddenInput.remove();
  }

  // ==========================================================================
  // STATİK METOTLAR
  // ==========================================================================

  /**
   * DOM'daki [data-mask] olan tüm inputları tek seferde otomatik başlatır
   */
  static init(selector = '[data-mask]') {
    const els = typeof selector === 'string' ? document.querySelectorAll(selector) : [selector];
    const instances = [];
    els.forEach(el => {
      if (!el._dijitalMask) {
        const mask = new DijitalMask(el);
        el._dijitalMask = mask;
        instances.push(mask);
      }
    });
    return instances;
  }

  /**
   * Belirli bir maskeyi programatik uygular
   */
  static mask(target, options) {
    return new DijitalMask(target, options);
  }
}

// Global browser environment export
if (typeof window !== 'undefined') {
  window.DijitalMask = DijitalMask;

  // Sayfa yüklendiğinde [data-mask] öğelerini otomatik bağla
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => DijitalMask.init());
  } else {
    DijitalMask.init();
  }
}

export default DijitalMask;
